(function(win, lib) {
  var winDoc = win.document
  var docEl = winDoc.documentElement
  var metaFlexible = winDoc.querySelector('meta[name="flexible"]')
  var metaViewport = winDoc.querySelector('meta[name="viewport"]')

  var libFlexible = lib.flexible || (lib.flexible = {})
  var deviceScale = 0
  var scaleDpr = 0
  var timeOut

  if (metaViewport) {
    var isMatch = metaViewport.getAttribute('content').match(/initial\-scale=([\d\.]+)/)
    if (isMatch) {
      deviceScale = parseFloat(isMatch[1])
      scaleDpr = parseInt(1 / deviceScale)
    }
  } else if (metaFlexible) {
    var content = metaFlexible.getAttribute('content')
    if (content) {
      var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/)
      if (maximumDpr) {
        scaleDpr = parseFloat(maximumDpr[1])
        deviceScale = parseFloat((1 / scaleDpr).toFixed(2))
      }
      var initialDpr = content.match(/initial\-dpr=([\d\.]+)/)
      if (initialDpr) {
        scaleDpr = parseFloat(initialDpr[1])
        deviceScale = parseFloat((1 / scaleDpr).toFixed(2))
      }
    }
  }

  if (!scaleDpr && !deviceScale) {
    var pixelRatio = win.devicePixelRatio
    var isIOS = win.navigator.appVersion.match(/iphone/gi)
    if (isIOS) {
      // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
      if (pixelRatio >= 3 && (!scaleDpr || scaleDpr >= 3)) {
        scaleDpr = 3
      } else if (pixelRatio >= 2 && (!scaleDpr || scaleDpr >= 2)) {
        scaleDpr = 2
      } else {
        scaleDpr = 1
      }
    } else {
      // 其他设备下，仍旧使用1倍的方案
      scaleDpr = 1
    }
    deviceScale = 1 / scaleDpr
  }

  docEl.setAttribute('data-dpr', scaleDpr)
  if (!metaViewport) {
    metaViewport = winDoc.createElement('meta')
    metaViewport.setAttribute('content',
      'initial-scale=' + deviceScale + ', maximum-scale=' + deviceScale + ', minimum-scale=' + deviceScale + ', user-scalable=no')
    metaViewport.setAttribute('name', 'viewport')
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaViewport)
    } else {
      var wrap = winDoc.createElement('div')
      wrap.appendChild(metaViewport)
      winDoc.write(wrap.innerHTML)
    }
  }

  function remRefresh() {
    var clientWidth = docEl.getBoundingClientRect().width
    if (clientWidth / scaleDpr > 540) {
      clientWidth = clientWidth * scaleDpr
    }

    // - 由于 Edge 更新后导致 docEl.getBoundingClientRect().width 取宽度不准，总是差 1 个像素，保险起见，判断的像素数值都在原有的基础上 -3
    // + edge 又更新拉，给你加了个边栏。边栏的宽度会让 1920 变成 1873，所以在原有的宽度上都 -47，为了好算，直接 -50吧
    /**
     * 1280 -> 1230
     * 1920 -> 1870
     * 2560 -> 2510
     * 3840 -> 3790
     * 4560 -> 4510
     */
    clientWidth = clientWidth > 4510 ? 4096 : clientWidth >= 3790 ? 3840 : clientWidth >= 2510 ? 2560 :clientWidth >= 1870 ? 1920 : clientWidth >= 1230 ? 1280 : clientWidth
    var rem = clientWidth < 1280 ? 128 : clientWidth / 10
    docEl.style.fontSize = rem + 'px'
    libFlexible.rem = win.rem = rem
  }

  function timeoutFun(timeOut,) {
    clearTimeout(timeOut)
    timeOut = setTimeout(remRefresh, 300)
  }

  win.addEventListener('resize', function() {
    timeoutFun(timeOut)
  }, false)
  win.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      timeoutFun(timeOut)
    }
  }, false)

  if (winDoc.readyState === 'complete') {
    winDoc.body.style.fontSize = 12 * scaleDpr + 'px'
  } else {
    winDoc.addEventListener('DOMContentLoaded', function(e) {
      winDoc.body.style.fontSize = 12 * scaleDpr + 'px'
    }, false)
  }

  remRefresh()

  win.dpr = scaleDpr
  libFlexible.dpr = win.dpr
  libFlexible.refreshRem = remRefresh
  libFlexible.px2rem = function(d) {
    let val = parseFloat(d) / this.rem
    if (typeof d === 'string' && d.match(/px$/)) {
      val = val + 'rem'
    }
    return val
  }

  libFlexible.rem2px = function(d) {
    let val = this.rem * parseFloat(d)
    if (d.match(/rem$/) && typeof d === 'string') {
      val = val + 'px'
    }
    return val
  }
})(window, window['lib'] || (window['lib'] = {}))
